
import { LabelAssignment, Time } from '@/model';
import labels from '@/store/labels';
import users from '@/store/users';
import { groupBy, notEmpty } from '@/util/array-util';
import Vue from 'vue';
import SelectionResultLabelPanel from './SelectionResultLabelPanel.vue';

interface Event {
  time?: Time;
  userId?: number;
  type: 'assignment' | 'deletion';
  labels: number[];
}

export default Vue.extend({
  components: { SelectionResultLabelPanel },
  name: 'FragmentLabelHistory',
  props: {
    assignments: { type: Array as () => LabelAssignment[], required: true },
  },

  methods: {
    history(assignments: LabelAssignment[]) {
      const additions: Event[] = Array.from(groupBy(assignments, (a) => `${a.userId}:${a.time}`))
        .map(([_, events]) => ({
          time: events[0].time,
          userId: events[0].userId,
          type: 'assignment',
          labels: events.map((e) => e.labelId),
        }));

      const deletions: Event[] = Array.from(groupBy(assignments.filter((d) => d.deleted), (a) => `${a.deletedBy}:${a.deleted}`))
        .map(([_, events]) => ({
          time: events[0].deleted,
          userId: events[0].deletedBy,
          type: 'deletion',
          labels: events.map((e) => e.labelId),
        }));

      return [...additions, ...deletions]
        .sort(this.eventCompare);
    },
    eventCompare(a: Event, b: Event) {
      if (a.time && b.time) {
        const timeDiff = b.time - a.time;
        return timeDiff === 0 ? a.type.localeCompare(b.type) : timeDiff;
      }
      return 0;
    },
    labelLookup(labelIds: number[]) {
      return labelIds.map((id) => labels.getters.lookup.get(id)).filter(notEmpty);
    },
    user(userId: number) {
      return users.getters.lookup.get(userId)?.displayName;
    },
    time(time: Time) {
      return Time.asString(time);
    },
  },
});
